import {
  FiLogIn, FiFolder, FiUpload, FiUsers, FiFileText, FiDownload, FiTarget,
  FiDollarSign, FiKey, FiMail, FiClipboard, FiCheckSquare, FiTrendingUp,
  FiCreditCard, FiUserCheck, FiCompass, FiCpu, FiActivity,
} from "react-icons/fi";

// Paleta do design system Vidal (mesmas cores de config/modules.js e designTokens)
export const IOS = {
  blue: "#3b82f6",
  green: "#10b981",
  indigo: "#6366f1",
  orange: "#f59e0b",
  pink: "#ec4899",
  purple: "#8b5cf6",
  red: "#ef4444",
  teal: "#06b6d4",
  yellow: "#eab308",
  mint: "#14b8a6",
  gray: "#64748b",
};

export const MODULE_META = {
  auth: { label: "Autenticação", icon: FiLogIn, color: IOS.gray },
  projects: { label: "Projetos", icon: FiFolder, color: IOS.indigo },
  files: { label: "Arquivos", icon: FiUpload, color: IOS.blue },
  users: { label: "Usuários", icon: FiUsers, color: IOS.teal },
  sped: { label: "SPED", icon: FiFileText, color: IOS.purple },
  xml: { label: "Download XML", icon: FiDownload, color: IOS.green },
  xml_scan: { label: "XML Scan", icon: FiTarget, color: IOS.orange },
  creditos: { label: "Créditos", icon: FiDollarSign, color: IOS.mint },
  certificates: { label: "Certificados", icon: FiKey, color: IOS.yellow },
  email_marketing: { label: "Email Marketing", icon: FiMail, color: IOS.pink },
  plcom: { label: "PLCom", icon: FiClipboard, color: IOS.blue },
  validacao_fiscal: { label: "Validação Fiscal", icon: FiCheckSquare, color: IOS.teal },
  reforma_tributaria: { label: "Reforma Tributária", icon: FiTrendingUp, color: IOS.green },
  subscriptions: { label: "Assinatura", icon: FiCreditCard, color: IOS.orange },
  simulation: { label: "Simulação", icon: FiUserCheck, color: IOS.red },
  questionario_fornecedores: { label: "Questionário Fornecedores", icon: FiClipboard, color: IOS.teal },
  navigation: { label: "Navegação", icon: FiCompass, color: IOS.blue },
  worker: { label: "Tarefa em segundo plano", icon: FiCpu, color: IOS.purple },
};

export const moduleMeta = (m) =>
  MODULE_META[m] || { label: m || "—", icon: FiActivity, color: IOS.gray };

export const ACTION_LABELS = {
  login: "Entrou no sistema",
  demo_login: "Entrou no modo demo",
  register: "Criou uma conta",
  forgot_password: "Pediu recuperação de senha",
  reset_password: "Redefiniu a senha",
  change_password: "Trocou a senha",
  create_project: "Criou um projeto",
  update_project_users: "Alterou os usuários do projeto",
  update_project_permissions: "Alterou os acessos do projeto",
  update_fiscal_info: "Alterou os dados fiscais",
  update_atividade_industrial: "Alterou atividade industrial",
  reset_sped_data: "Resetou os dados de SPED",
  upload_files: "Enviou arquivos",
  upload_file: "Enviou um arquivo",
  start_upload_processing: "Iniciou processamento do upload",
  delete_upload: "Excluiu um upload",
  download_upload: "Baixou um arquivo",
  download_missing_keys: "Baixou chaves faltantes",
  download_sped_files: "Baixou arquivos SPED",
  download_files_report: "Baixou relatório de arquivos",
  create_user: "Criou um usuário",
  invite_user: "Convidou um usuário",
  accept_invite: "Aceitou um convite",
  update_user: "Editou um usuário",
  delete_user: "Excluiu um usuário",
  add_user_to_project: "Adicionou usuário ao projeto",
  remove_user_from_project: "Removeu usuário do projeto",
  upload_sped: "Enviou SPED",
  process_speds: "Processou SPEDs",
  reprocess_speds: "Reprocessou SPEDs",
  cancel_processing: "Cancelou processamento",
  request_sped_download: "Pediu download de SPEDs",
  download_sped_zip: "Baixou SPEDs",
  delete_sped_download: "Excluiu download de SPED",
  request_xml_download_txt: "Pediu XMLs por TXT",
  request_xml_download_filter: "Pediu XMLs por filtros",
  download_xml_zip: "Baixou XMLs",
  download_xml_faltantes: "Baixou chaves faltantes",
  download_xml_report: "Baixou relatório de XMLs",
  delete_xml_download: "Excluiu download de XML",
  upload_xml_scan: "Enviou lote ao XML Scan",
  delete_xml_scan: "Excluiu análise do XML Scan",
  revisor_upload: "Enviou SPED ao Revisor",
  revisor_process: "Rodou o Revisor",
  revisor_delete_report: "Excluiu relatório do Revisor",
  revisor_download_faltantes: "Baixou faltantes do Revisor",
  revisor_download_xmls: "Baixou XMLs do Revisor",
  revisor_download_pdfs: "Baixou PDFs do Revisor",
  revisor_download_all: "Baixou tudo do Revisor",
  run_credit_analysis: "Analisou créditos",
  reset_creditos: "Resetou créditos",
  export_creditos: "Exportou créditos",
  upload_certificates: "Enviou certificados",
  delete_certificate: "Excluiu certificado",
  create_list: "Criou lista de contatos",
  delete_list: "Excluiu lista de contatos",
  import_contacts: "Importou contatos",
  remove_contacts: "Removeu contatos",
  create_campaign: "Criou campanha",
  update_campaign: "Editou campanha",
  delete_campaign: "Excluiu campanha",
  send_campaign: "Disparou campanha",
  send_test_campaign: "Enviou teste de campanha",
  schedule_campaign: "Agendou campanha",
  unschedule_campaign: "Cancelou agendamento",
  upload_plcom: "Enviou movimento ao PLCom",
  add_xmls: "Adicionou XMLs ao relatório",
  update_relatorio: "Atualizou relatório",
  delete_relatorio: "Excluiu relatório",
  create_competencia: "Abriu competência",
  approve_ajuste: "Aprovou ajuste",
  approve_dossie: "Aprovou dossiê",
  decide_divergencia: "Decidiu divergência",
  calcular_formacao_preco: "Calculou formação de preço",
  importar_ecd: "Importou ECD",
  create_simulacao: "Criou simulação",
  delete_simulacao: "Excluiu simulação",
  checkout: "Iniciou checkout",
  start_trial: "Iniciou trial",
  change_plan: "Trocou de plano",
  cancel_subscription: "Cancelou assinatura",
  start_simulation: "Começou a simular um usuário",
  stop_simulation: "Parou a simulação",
  create_fornecedor: "Cadastrou fornecedor",
  import_fornecedores: "Importou fornecedores",
  delete_fornecedor: "Removeu fornecedor",
  delete_resposta: "Excluiu resposta de fornecedor",
};

export const SCREEN_LABELS = {
  files: "Arquivos",
  transactions: "Movimentações",
  "notificacoes-fiscais": "Notificações Fiscais",
  products: "Produtos",
  clients: "Clientes",
  suppliers: "Fornecedores",
  "reforma-tributaria": "Reforma Tributária",
  "validacao-fiscal": "Validação Fiscal",
  plcom: "PLCom",
  "sped-reviewer": "Revisor SPED",
  downloads: "Downloads",
  "sped-processor": "Processador SPED",
  "xml-scan": "XML Scan",
  creditos: "Créditos",
  certificates: "Certificados",
  "email-marketing": "Email Marketing",
  "nfe-downloader": "NFe Downloader",
  "lead-scraper": "Lead Scraper",
  users: "Usuários",
  projects: "Projetos",
  admin: "Admin",
  "automec-fornecedores": "Questionário Fornecedores",
  "activity-logs": "Atividades",
};

export const screenLabel = (s) => SCREEN_LABELS[s] || s;

export const describe = (e) => {
  if (!e) return "";
  if (e.type === "page_view") return `Abriu ${screenLabel(e.action)}`;
  if (e.type === "task") return `Tarefa ${String(e.action || "").replace(/_/g, " ")}`;
  return ACTION_LABELS[e.action] || String(e.action || "").replace(/_/g, " ");
};

// Ícone/cor do evento: telas usam ícone de navegação, ações usam o módulo
export const eventMeta = (e) => {
  if (e.type === "page_view") return MODULE_META.navigation;
  if (e.type === "task") return MODULE_META.worker;
  return moduleMeta(e.module);
};

// ─── Datas ──────────────────────────────────────────────────────────────────
const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };

export const dayKey = (iso) => {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const dayLabel = (iso) => {
  const d = startOfDay(iso);
  const today = startOfDay(new Date());
  const diff = Math.round((today - d) / 86400000);
  if (diff === 0) return "Hoje";
  if (diff === 1) return "Ontem";
  const label = d.toLocaleDateString("pt-BR", diff < 7 ? { weekday: "long" } : { weekday: "short", day: "numeric", month: "short" });
  return label.charAt(0).toUpperCase() + label.slice(1);
};

export const timeLabel = (iso) =>
  iso ? new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : "";

export const relativeTime = (iso) => {
  if (!iso) return "—";
  const s = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 45) return "agora";
  const m = Math.round(s / 60);
  if (m < 60) return `há ${m} min`;
  const h = Math.round(m / 60);
  if (h < 24) return `há ${h} h`;
  const d = Math.round(h / 24);
  if (d < 7) return `há ${d} d`;
  return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
};

export const fullDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("pt-BR", { weekday: "short", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "—";

export const fmtDuration = (ms) => {
  if (ms === null || ms === undefined) return null;
  if (ms < 1000) return `${ms} ms`;
  const s = ms / 1000;
  if (s < 60) return `${s.toFixed(1)} s`;
  return `${Math.floor(s / 60)}m ${Math.round(s % 60)}s`;
};

export const isOnline = (iso) => iso && Date.now() - new Date(iso).getTime() < 15 * 60 * 1000;

// ─── Períodos ───────────────────────────────────────────────────────────────
export const PERIODS = [
  { key: "today", label: "Hoje" },
  { key: "7d", label: "7d" },
  { key: "30d", label: "30d" },
  { key: "90d", label: "90d" },
  { key: "all", label: "Tudo" },
];

export const PERIOD_TEXT = {
  today: "hoje",
  "7d": "nos últimos 7 dias",
  "30d": "nos últimos 30 dias",
  "90d": "nos últimos 90 dias",
  all: "desde o início",
};

export const periodRange = (period) => {
  if (period === "today") {
    const d = startOfDay(new Date());
    return { dateFrom: d.toISOString() };
  }
  const days = { "7d": 7, "30d": 30, "90d": 90 }[period];
  if (days) return { dateFrom: new Date(Date.now() - days * 86400000).toISOString() };
  return {};
};

// ─── Avatar ─────────────────────────────────────────────────────────────────
export const initials = (name = "") =>
  String(name)
    .replace(/\b(LTDA|S\/?A|ME|EPP|EIRELI|DE|DA|DO|DOS|DAS|E)\b/gi, " ")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase() || "?";

const FALLBACK_COLORS = [IOS.blue, IOS.indigo, IOS.purple, IOS.pink, IOS.orange, IOS.green, IOS.teal];
export const colorFor = (id = "", color) => {
  if (color) return color;
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return FALLBACK_COLORS[h % FALLBACK_COLORS.length];
};
